module.exports = {
	AMPLITUDE_API_KEY: 'e5abe193f4687867cbc42dbd31798110',
	AUTH_SERVER_URL: '/auth',
	AUTH_API_URL: '/api',
	AUTH_API_APPLICATION_KEY: 'smartbuildings',
	AUTH_API_APPLICATION_SECRET: '0c11d3e1-0da5-11e8-baf6-f1ce3d466cc4',
	CHARGEBEE_URL: 'https://js.chargebee.com/v2/chargebee.js',
	CHARGEBEE_SITE: 'ecobee',
	BUGSNAG_API_KEY: '74a9a716d6d02bde54f05d70dd470e43',
	GOOGLE_ANALYTICS_TRACKING_ID: 'UA-148378333-1',
	GOOGLE_TAG_MANAGER_AUTH: 'DDT9bdFpP5XwQYDiJhyfOA',
	GOOGLE_TAG_MANAGER_ENV: 'env-1',
	GOOGLE_TAG_MANAGER_ID: 'GTM-PHLT7RK',
	INTERCOM_APP_ID: 'jvd56aod',
	ENV: 'production',
	LD_CLIENT_ID: '5cc9e6ba891264081d0a2f34',
	ROUTER_BASE_NAME: '/',
	PAGINATION_RESULTS_PER_PAGE: 25,
	USER_PREFERENCES_DEFAULT: {
		useCelsius: false,
	},
}
